import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Formik, Field, Form, ErrorMessage } from "formik";
import { useNavigate, useParams } from 'react-router-dom';
import ConfirmationModal from '../shared/ConfirmationModal';
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import NewconfirmationModal from '../shared/NewconfirmationModal';
import AllFailureModal from '../shared/AllFailureModal';
const CityEdit = () => {
  const { cityId } = useParams();
  const cityDataInitialState = { city_id: cityId, city_name: "", state_name: "", country: "India", pin_code: "" };
  const [cityData, setCityData] = useState(cityDataInitialState);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [modalAction, setModalAction] = useState(null);
  const [updatedValues, setUpdatedValues] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [failureMessage, setFailureMessage] = useState('');
  const headers = {
    "x-access-token": localStorage.getItem("jwttoken") || "",
  };

  const callCityUpdateApi = async (data) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}cities/updatecity`;
      await axios.put(url, data, { headers });
      setSuccessMessage('City updated successfully!');
      setShowSuccessModal(true);
      setTimeout(() => {
        navigate('/citylist');
      }, 3000);
    } catch (error) {
      setShowSuccessModal(false);
      if (error.response && error.response.status === 409) {
        setFailureMessage('City name already exists! Please choose a different name.');
      } else {
        setFailureMessage('Error updating city');
      }
      setShowFailureModal(true);
    }
  };

  const getCityByIdApi = async (cityId) => {
    try {
      const url = process.env.REACT_APP_API_URL + `cities/showcitybyid/${cityId}`;
      const response = await axios.get(url);
      //console.log(response);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getCityByIdApi(cityId);
        setCityData(data[0]);
        console.log("Updated City Data:", data[0]);
      } catch (error) {
        console.log(error);
        setFailureMessage('Error fetching city data');
        setShowFailureModal(true);
      }
    };

    fetchData();
  }, [cityId]);

  const handleSubmit = async (values) => {
    if (JSON.stringify(values) === JSON.stringify(cityData)) {
      setModalAction('noUpdate');
      setSuccessMessage("No Update Made")
      setShowSuccessModal(true)
    } else {
      setUpdatedValues(values);
      setModalAction('OK');
      setShowModal(true);
    }
  };

  const handleConfirm = async () => {
    if (modalAction === 'OK' && updatedValues) {
      try {
        await callCityUpdateApi(updatedValues);
      } catch (error) {
        console.error("Error updating city:", error);
        setFailureMessage("Error updating city");
        setShowFailureModal(true);
      }
    } else if (modalAction === 'noUpdate') {
      setSuccessMessage("No updates were made.");
      setShowSuccessModal(true);
    }
    setShowModal(false);
  };

  const handleCancel = () => {
    setShowModal(false);
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="shadow">
            <Card.Header className="bg-info text-white text-center">
              <h4>Edit City Details</h4>
            </Card.Header>
            <Card.Body>
              <Formik
                enableReinitialize={true}
                initialValues={cityData}
                validate={(values) => {
                  const errors = {};
                  if (!values.city_name.trim()) errors.city_name = "City name is required";
                  if (!values.state_name) errors.state_name = "State is required";
                  if (!values.pin_code.trim()) {
                    errors.pin_code = "Pincode is required";
                  } else if (!/^\d{6}$/.test(values.pin_code)) {
                    errors.pin_code = "Pincode must be a 6-digit number";
                  }
                  return errors;
                }}
                onSubmit={handleSubmit}
              >
                {() => (
                  <Form>
                    <Row className="mb-3">
                      <Col md={12}>
                        <label htmlFor="city_id" className="form-label">City ID:</label>
                        <Field
                          type="text"
                          name="city_id"
                          id="city_id"
                          className="form-control"
                          disabled
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={12}>
                        <label htmlFor="city_name" className="form-label">City Name:</label>
                        <Field
                          name="city_name"
                          id="city_name"
                          type="text"
                          className="form-control"
                        />
                        <ErrorMessage
                          name="city_name"
                          component="div"
                          className="text-danger small mt-1"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={12}>
                        <label htmlFor="state_name" className="form-label">State:</label>
                        <Field
                          as="select"
                          name="state_name"
                          className={`form-select`}
                        >
                          <option value="">Select State</option>
                          <option value="Andhra Pradesh">Andhra Pradesh</option>
                          <option value="Arunachal Pradesh">Arunachal Pradesh</option>
                          <option value="Assam">Assam</option>
                          <option value="Bihar">Bihar</option>
                          <option value="Chhattisgarh">Chhattisgarh</option>
                          <option value="Goa">Goa</option>
                          <option value="Gujarat">Gujarat</option>
                          <option value="Haryana">Haryana</option>
                          <option value="Himachal Pradesh">Himachal Pradesh</option>
                          <option value="Jharkhand">Jharkhand</option>
                          <option value="Karnataka">Karnataka</option>
                          <option value="Kerala">Kerala</option>
                          <option value="Madhya Pradesh">Madhya Pradesh</option>
                          <option value="Maharashtra">Maharashtra</option>
                          <option value="Manipur">Manipur</option>
                          <option value="Meghalaya">Meghalaya</option>
                          <option value="Mizoram">Mizoram</option>
                          <option value="Nagaland">Nagaland</option>
                          <option value="Odisha">Odisha</option>
                          <option value="Punjab">Punjab</option>
                          <option value="Rajasthan">Rajasthan</option>
                          <option value="Sikkim">Sikkim</option>
                          <option value="Tamil Nadu">Tamil Nadu</option>
                          <option value="Telangana">Telangana</option>
                          <option value="Tripura">Tripura</option>
                          <option value="Uttar Pradesh">Uttar Pradesh</option>
                          <option value="Uttarakhand">Uttarakhand</option>
                          <option value="West Bengal">West Bengal</option>
                        </Field>
                        <ErrorMessage name="state_name" component="div" className="text-danger small mt-1" />
                      </Col>
                    </Row>

                    {/* Country (Disabled, Default India) */}
                    <Row className="mb-3">
                      <Col md={12}>
                        <label htmlFor="country" className="form-label">Country:</label>
                        <Field
                          name="country"
                          type="text"
                          className="form-control"
                          disabled
                        />
                      </Col>
                    </Row>

                    {/* Pincode */}
                    <Row className="mb-3">
                      <Col md={12}>
                        <label htmlFor="pin_code" className="form-label">Pincode:</label>
                        <Field
                          name="pin_code"
                          type="text"
                          className={`form-control`}
                          placeholder="Enter Pincode"
                        />
                        <ErrorMessage name="pin_code" component="div" className="text-danger small mt-1" />
                      </Col>
                    </Row>
                    <div className="text-center d-flex justify-content-center gap-2">
                      <button
                        type="submit"
                        className="btn btn-success"
                      >
                        Update
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => navigate('/citylist')}
                      >
                        Go Back
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>

              <ConfirmationModal
                show={showModal}
                onHide={handleCancel}
                modalMessage={modalAction === 'noUpdate' ? "No updates were made." : "Are you sure you want to save changes?"}
                operationType={modalAction}
                confirmation={handleConfirm}
              />

              <NewconfirmationModal
                show={showSuccessModal}
                onHide={() => setShowSuccessModal(false)}
                modalMessage={successMessage}
                operationType="OK"
                timeoutDuration={3000} />
              <AllFailureModal show={showFailureModal} onHide={() => setShowFailureModal(false)} modalMessage={failureMessage} operationType="OK" timeoutDuration={3000} />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default CityEdit;
